import { AvatarProfileSizeType } from '../../../../../../components/avatarProfile/types/avatarProfileSizeType';
import { AvatarProfileStateType } from '../../../../../../components/avatarProfile/types/avatarProfileStateType';
import { AvatarProfileVariantType } from '../../../../../../components/avatarProfile/types/avatarProfileVariantType';
import { SelectionIndicatorSizeType, SelectionIndicatorVariantType, } from '../../../../../../components/selectionIndicator/types/selectionIndicator';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../text/variants';
const buildCommonIconProps = (FOUNDATIONS) => ({
    rootContainer: {
        display: 'flex',
        flex_direction: 'column',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_150,
    },
    avatarWrapper: {
        position: 'relative',
    },
    avatarContainer: {
        display: 'flex',
        justify_content: 'center',
        align_items: 'center',
        border_radius: FOUNDATIONS.radius_1000,
        background_color: FOUNDATIONS.color_comp_resources_avatarprofile_selector_bg,
        border_style: 'solid',
        border_width: FOUNDATIONS.border_50,
        //TODO: We dont have this token yet FOUNDATIONS.color_comp_resources_avatarprofile_selector_border
        border_color: FOUNDATIONS.color_comp_resources_avatarprofile_initials_default_border,
        cursor: 'pointer',
    },
    avatarContent: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        display: 'flex',
        align_items: 'center',
        justify_content: 'center',
        pointer_events: 'none',
    },
    icon: {
        color: FOUNDATIONS.color_comp_resources_avatarprofile_selector_icon_icon,
    },
    selectionIndicatorContainer: {
        position: 'absolute',
        bottom: '-0.25rem',
        right: '-0.25rem',
    },
    labelContainer: {
        width: '4.375rem',
    },
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_500,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_50,
        text_align: 'center',
    },
});
const buildCommonIconExtraExtraSmallProps = (FOUNDATIONS) => {
    const commonIconProps = buildCommonIconProps(FOUNDATIONS);
    return {
        ...commonIconProps,
        avatarContainer: {
            ...commonIconProps.avatarContainer,
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
        },
        icon: {
            ...commonIconProps.icon,
            width: FOUNDATIONS.size_200,
            height: FOUNDATIONS.size_200,
        },
    };
};
const buildCommonIconExtraSmallProps = (FOUNDATIONS) => {
    const commonIconProps = buildCommonIconProps(FOUNDATIONS);
    return {
        ...commonIconProps,
        avatarContainer: {
            ...commonIconProps.avatarContainer,
            width: FOUNDATIONS.size_400,
            height: FOUNDATIONS.size_400,
        },
        icon: {
            ...commonIconProps.icon,
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
        },
    };
};
const buildCommonIconSmallProps = (FOUNDATIONS) => {
    const commonIconProps = buildCommonIconProps(FOUNDATIONS);
    return {
        ...commonIconProps,
        avatarContainer: {
            ...commonIconProps.avatarContainer,
            width: '3rem',
            height: '3rem',
        },
        icon: {
            ...commonIconProps.icon,
            width: FOUNDATIONS.size_350,
            height: FOUNDATIONS.size_350,
        },
    };
};
const buildCommonIconMediumProps = (FOUNDATIONS) => {
    const commonIconProps = buildCommonIconProps(FOUNDATIONS);
    return {
        ...commonIconProps,
        avatarContainer: {
            ...commonIconProps.avatarContainer,
            width: '3.5rem',
            height: '3.5rem',
        },
        icon: {
            ...commonIconProps.icon,
            width: FOUNDATIONS.size_350,
            height: FOUNDATIONS.size_350,
        },
    };
};
const buildCommonIconLargeProps = (FOUNDATIONS) => {
    const commonIconProps = buildCommonIconProps(FOUNDATIONS);
    return {
        ...commonIconProps,
        avatarContainer: {
            ...commonIconProps.avatarContainer,
            width: '4rem',
            height: '4rem',
        },
        icon: {
            ...commonIconProps.icon,
            width: FOUNDATIONS.size_400,
            height: FOUNDATIONS.size_400,
        },
    };
};
const buildCommonIconExtraExtraLargeProps = (FOUNDATIONS) => {
    const commonIconProps = buildCommonIconProps(FOUNDATIONS);
    return {
        ...commonIconProps,
        avatarContainer: {
            ...commonIconProps.avatarContainer,
            width: FOUNDATIONS.size_1089,
            height: FOUNDATIONS.size_1089,
        },
        icon: {
            ...commonIconProps.icon,
            width: FOUNDATIONS.size_750,
            height: FOUNDATIONS.size_750,
        },
    };
};
export const getIconSelectorStyles = (FOUNDATIONS, FONT) => {
    const commonIconExtraExtraSmallProps = buildCommonIconExtraExtraSmallProps(FOUNDATIONS);
    const commonIconExtraSmallProps = buildCommonIconExtraSmallProps(FOUNDATIONS);
    const commonIconSmallProps = buildCommonIconSmallProps(FOUNDATIONS);
    const commonIconMediumProps = buildCommonIconMediumProps(FOUNDATIONS);
    const commonIconLargeProps = buildCommonIconLargeProps(FOUNDATIONS);
    const commonIconExtraExtraLargeProps = buildCommonIconExtraExtraLargeProps(FOUNDATIONS);
    return {
        [AvatarProfileVariantType.ICON_SELECTOR]: {
            [AvatarProfileSizeType.EXTRA_EXTRA_SMALL]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonIconExtraExtraSmallProps,
                },
                [AvatarProfileStateType.SELECTED]: {
                    ...commonIconExtraExtraSmallProps,
                    avatarContainer: {
                        ...commonIconExtraExtraSmallProps.avatarContainer,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.EXTRA_SMALL,
                    },
                },
                [AvatarProfileStateType.DISABLED]: {
                    ...commonIconExtraExtraSmallProps,
                    avatarContainer: {
                        ...commonIconExtraExtraSmallProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    icon: {
                        ...commonIconExtraExtraSmallProps.icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    label: {
                        ...commonIconExtraExtraSmallProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
                [AvatarProfileStateType.DISABLED_SELECTED]: {
                    ...commonIconExtraExtraSmallProps,
                    avatarContainer: {
                        ...commonIconExtraExtraSmallProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    icon: {
                        ...commonIconExtraExtraSmallProps.icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.EXTRA_SMALL,
                    },
                    label: {
                        ...commonIconExtraExtraSmallProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
            },
            [AvatarProfileSizeType.EXTRA_SMALL]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonIconExtraSmallProps,
                },
                [AvatarProfileStateType.SELECTED]: {
                    ...commonIconExtraSmallProps,
                    avatarContainer: {
                        ...commonIconExtraSmallProps.avatarContainer,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.EXTRA_SMALL,
                    },
                },
                [AvatarProfileStateType.DISABLED]: {
                    ...commonIconExtraSmallProps,
                    avatarContainer: {
                        ...commonIconExtraSmallProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    icon: {
                        ...commonIconExtraSmallProps.icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    label: {
                        ...commonIconExtraSmallProps.label,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                [AvatarProfileStateType.DISABLED_SELECTED]: {
                    ...commonIconExtraSmallProps,
                    avatarContainer: {
                        ...commonIconExtraSmallProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    icon: {
                        ...commonIconExtraSmallProps.icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.EXTRA_SMALL,
                    },
                    label: {
                        ...commonIconExtraSmallProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
            },
            [AvatarProfileSizeType.SMALL]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonIconSmallProps,
                },
                [AvatarProfileStateType.SELECTED]: {
                    ...commonIconSmallProps,
                    avatarContainer: {
                        ...commonIconSmallProps.avatarContainer,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.EXTRA_SMALL,
                    },
                },
                [AvatarProfileStateType.DISABLED]: {
                    ...commonIconSmallProps,
                    avatarContainer: {
                        ...commonIconSmallProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    icon: {
                        ...commonIconSmallProps.icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    label: {
                        ...commonIconSmallProps.label,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                [AvatarProfileStateType.DISABLED_SELECTED]: {
                    ...commonIconSmallProps,
                    avatarContainer: {
                        ...commonIconSmallProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    icon: {
                        ...commonIconSmallProps.icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.EXTRA_SMALL,
                    },
                    label: {
                        ...commonIconSmallProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
            },
            [AvatarProfileSizeType.MEDIUM]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonIconMediumProps,
                },
                [AvatarProfileStateType.SELECTED]: {
                    ...commonIconMediumProps,
                    avatarContainer: {
                        ...commonIconMediumProps.avatarContainer,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.SMALL,
                    },
                },
                [AvatarProfileStateType.DISABLED]: {
                    ...commonIconMediumProps,
                    avatarContainer: {
                        ...commonIconMediumProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    icon: {
                        ...commonIconMediumProps.icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    label: {
                        ...commonIconMediumProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
                [AvatarProfileStateType.DISABLED_SELECTED]: {
                    ...commonIconMediumProps,
                    avatarContainer: {
                        ...commonIconMediumProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    icon: {
                        ...commonIconMediumProps.icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.SMALL,
                    },
                    label: {
                        ...commonIconMediumProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
            },
            [AvatarProfileSizeType.LARGE]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonIconLargeProps,
                },
                [AvatarProfileStateType.SELECTED]: {
                    ...commonIconLargeProps,
                    avatarContainer: {
                        ...commonIconLargeProps.avatarContainer,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.SMALL,
                    },
                },
                [AvatarProfileStateType.DISABLED]: {
                    ...commonIconLargeProps,
                    avatarContainer: {
                        ...commonIconLargeProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    icon: {
                        ...commonIconLargeProps.icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    label: {
                        ...commonIconLargeProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
                [AvatarProfileStateType.DISABLED_SELECTED]: {
                    ...commonIconLargeProps,
                    avatarContainer: {
                        ...commonIconLargeProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    icon: {
                        ...commonIconLargeProps.icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.SMALL,
                    },
                    label: {
                        ...commonIconLargeProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
            },
            [AvatarProfileSizeType.EXTRA_EXTRA_LARGE]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonIconExtraExtraLargeProps,
                },
                [AvatarProfileStateType.SELECTED]: {
                    ...commonIconExtraExtraLargeProps,
                    avatarContainer: {
                        ...commonIconExtraExtraLargeProps.avatarContainer,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.SMALL,
                    },
                },
                [AvatarProfileStateType.DISABLED]: {
                    ...commonIconExtraExtraLargeProps,
                    avatarContainer: {
                        ...commonIconExtraExtraLargeProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    icon: {
                        ...commonIconExtraExtraLargeProps.icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    label: {
                        ...commonIconExtraExtraLargeProps.label,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                [AvatarProfileStateType.DISABLED_SELECTED]: {
                    ...commonIconExtraExtraLargeProps,
                    avatarContainer: {
                        ...commonIconExtraExtraLargeProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    icon: {
                        ...commonIconExtraExtraLargeProps.icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.SMALL,
                    },
                    label: {
                        ...commonIconExtraExtraLargeProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=iconSelector.js.map